<template>
  <div style="padding: 100px;">
    <Form :model="form" :rules="rules" ref="formRef">
      <!-- 图片上传部分 -->
      <FormItem label="图片上传" prop="image">
        <UploadImg
          ref="upload"
          :file-list="fileList"
          :before-upload="beforeUpload"
          :action="uploadAction"
          :show-file-list="false"
          :auto-upload="false"
          :accept="'image/*'"
          list-type="picture-card"
          :on-change="handleFileChange"
          :on-previewimg = "handlePreviewImageLocal"
        >
          <Button>点击上传图片</Button>
         
        </UploadImg>

        <!-- <div class="demo-upload-list" v-for="item in uploadList" :key="item.key">
          <template v-if="item.status === 'finished'">
              <img :src="webUrl+'?fid='+item.response.data">
              <div class="demo-upload-list-cover">
                  <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
          </template>
          <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
          </template>
      </div> -->


        <div v-if="fileList.length">
          <div  v-for="file in fileList" :key="file.uid" class="file-info demo-upload-list">
            <img v-if="file.preview" :src="file.preview" alt="image" class="preview-image" />
            <img v-else-if="file.imgurl" :src="file.imgurl" alt="image" class="preview-image" />
            <div class="demo-upload-list-cover">
                  <Icon type="ios-trash-outline" @click.native="handleRemove(file)"></Icon>
              </div>
          </div>
        </div>
      </FormItem>

      <!-- 其他表单项 -->
      <FormItem label="名称" prop="name">
        <Input v-model="form.name"></Input>
      </FormItem>

      <TimePicker
    
        v-model="timeValue" 
        @on-change="setDateChange($event,'timeValue')" 
      
        transfer  
        :editable="false"
        :format="'mm:ss'"  
        placement="bottom-end" 
        style="width: 168px"></TimePicker> 

        <ColorPicker
         :placeholder='$t("selectPlaceholder")'
         transfer
         v-model="color1" />

      <!-- 提交按钮 -->
      <FormItem>
        <Button type="primary" @click="submitForm">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import UploadImg from './upimglocal/upload.vue'
export default {
  data() {
    return {
      form: {
        name: '',
        image: null,  // 用来存储图片文件
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
      },
      fileList: [],  // 存储上传的文件列表
      uploadAction: '',  // 禁用自动上传，action 为空
      previewImagefileList:[],
      timeValue:'02:08',
      color1:''
    };
  },
  components:{UploadImg},
  methods: {
    setDateChange(e){
      console.log('e',e)
      console.log('timeValue',this.timeValue)
    },
    // 在上传前进行文件类型检查
    beforeUpload(file) {
      console.log('file',file)
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$Message.error('只能上传图片文件');
      }
      return isImage;  // 返回true表示允许上传
    },

    // 文件变化时的处理
    handleFileChange(info) {
      console.log('文件变化', info);
      // 在这里处理文件变化，可以显示预览、大小等信息
    },

    // 格式化文件大小
    formatSize(size) {
      if (size < 1024) return size + ' B';
      else if (size < 1048576) return (size / 1024).toFixed(2) + ' KB';
      else return (size / 1048576).toFixed(2) + ' MB';
    },

    // 提交表单时上传图片
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.uploadImage();  // 手动上传文件
        } else {
          this.$Message.error('表单验证失败！');
        }
      });
    },

    // 手动上传图片
    uploadImage() {
      if (this.fileList.length === 0) {
        this.$Message.error('请上传图片！');
        return;
      }

      const formData = new FormData();
      this.fileList.forEach(file => {
        if(file.preview){

          formData.append('file', file.raw);  // 使用raw属性获取原始文件
        }
      });

      // 你可以在这里发送图片到服务器
      // 示例使用axios发送请求
      // axios.post('/upload-endpoint', formData)
      //   .then(response => {
      //     this.$Message.success('图片上传成功');
      //   })
      //   .catch(error => {
      //     this.$Message.error('图片上传失败');
      //   });

      this.$Message.success('图片上传成功');  // 仅为示例，实际需要请求服务器
    },
    handlePreviewImageLocal(list){
      this.fileList = list
    },
    handleRemove(file){
      const fileList = this.$refs.upload.fileList;
        let index = fileList.indexOf(file)
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        this.$emit('removeThumbUrl', index);
    }
  },
};
</script>

<style scoped>
.file-info {
  margin-top: 10px;
  border: 1px solid #e4e7ed;
  padding: 10px;
  border-radius: 5px;
}

.preview-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-bottom: 10px;
}
.demo-upload-list{
          display: inline-block;
          width: 60px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          border: 1px solid transparent;
          border-radius: 4px;
          overflow: hidden;
          background: #fff;
          position: relative;
          box-shadow: 0 1px 1px rgba(0,0,0,.2);
          margin-right: 4px;
      }
      .demo-upload-list img{
          width: 100%;
          height: 100%;
          object-fit: contain;
      }
      .demo-upload-list-cover{
          display: none;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0,0,0,.6);
      }
      .demo-upload-list:hover .demo-upload-list-cover{
          display: block;
      }
      .demo-upload-list-cover i{
          color: #fff;
          font-size: 20px;
          cursor: pointer;
          margin: 0 2px;
      }
</style>

